<div class="login-body">
  <div class="login-panel ">
    <div class="login-header">
      <img class="login-logo" [src]="app.getLogoLoginPngUrl()" />
      <h1>Aktivierung</h1>
      <h2>{{app.appName}}</h2>
    </div>
    @if (running) {
      <div>
        <div>Aktivierung läuft ...</div>
        <p-progressSpinner></p-progressSpinner>
      </div>
    }
    @if (!running) {
      <p-message [severity]="resultType" styleClass="mr-2">{{resultMessage}}</p-message>
    }
    @if (!running) {
      <div class="col-12">
        <a [routerLink]="['/base', 'login']">
          <p-button styleClass="width100p" icon="fas fa-sign-in" label="Zur Anmeldung">
          </p-button>
        </a>
      </div>
    }
  </div>
